var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('topBar',{attrs:{"showTopBar":_vm.showTopBar}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('Footer',{attrs:{"showFooter":_vm.showFooter}}),_vm._v(" "),_c('diandiFooter',{attrs:{"showDiandiFooter":_vm.showDiandiFooter}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-9b08e9e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 